import React, { ReactNode } from "react";
import { NativeHtml } from "../../../../types/nativeHtml";
import { createGlobalStyle } from "styled-components";

const Style = createGlobalStyle`
.LoadingPage {
	position: relative;
	height: 100vh;
}
.LoadingWrapper {
	display: flex;
	position: fixed;
	background: #035FA4;
	width: 100%;
	height: 100vh;
	top: 0px;
	z-index: 9999;
}
.loadingContainer {
	width: 100%;
	align-self: center;
}
.fa-full-page {
	zoom: 1.5;
	color: #fff;
}
`;

const LoadingPage: React.FC<{ children?: ReactNode } & NativeHtml> = ({
	children,
	id,
	className,
}) => {
	const additionalClasses = className ? className : "";
	return (
		<>
			<Style />
			<div id={id} className={`LoadingPage ${additionalClasses}`}>
				<div className="LoadingWrapper">
					<div className="text-center on-dark util-margin-0 loadingContainer">
						<i
							className="fa fa-5x fa-spinner fa-spin fa-full-page"
							aria-hidden="true"
						></i>
					</div>
				</div>
				{children}
			</div>
		</>
	);
};

export default LoadingPage;
